import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PhaserGame from '../components/PhaserComponent';
import { useAuthContext } from '../context/AuthContext';
import useUserPokemons from '../hooks/Pokemons/useUserPokemon';
import PokemonPage from './PokemonPage';
import TaskPage from './TaskPage';
import TitlePage from './TitlePage';
import ProfilePanel from './ProfilePanel';
import stylesPeriod from '../styles/Period.module.css';
import relief from '../styles/Relief.module.css';
import Period from '../utils/Period';
import styles from '../styles/Dashboard.module.css';

const Dashboard = () => {
    // États pour gérer l'ouverture/fermeture des pages
    const [isPokePageOpen, setIsPokePageOpen] = useState(false);
    const [isTaskPageOpen, setIsTaskPageOpen] = useState(false);
    const [isProfilePageOpen, setIsProfilePageOpen] = useState(false);
    // États pour gérer les animations de sortie
    const [isPokePageClosing, setIsPokePageClosing] = useState(false);
    const [isTaskPageClosing, setIsTaskPageClosing] = useState(false);
    const [isProfilePageClosing, setIsProfilePageClosing] = useState(false);
    const { user, isLoading, isAuthenticated } = useAuthContext();
    const { userPokemons, isLoading: userPokemonsLoading } = useUserPokemons();
    const navigate = useNavigate();
    const selectedPokemon = user?.selectedPokemon || userPokemons[0];
    let { period } = Period();


    useEffect(() => {
        if (user && !user.hasSelectedStarter) {
            navigate('/starter_selection');
        }
    }, [user, userPokemons, userPokemonsLoading, navigate]);

    // Gestion de la fermeture de ProfilePage avec animation
    const handleCloseProfilePage = () => {
        // Active l'état de fermeture qui déclenche l'animation CSS
        setIsProfilePageClosing(true);
        // Attend la fin de l'animation (300ms) avant de réellement fermer la page
        setTimeout(() => {
            setIsProfilePageOpen(false);
            setIsProfilePageClosing(false);
        }, 300); // Durée qui correspond à la transition CSS dans Dashboard.module.css
    };
    // Gestion de la fermeture de PokePage avec animation
    const handleClosePokePage = () => {
        // Active l'état de fermeture qui déclenche l'animation CSS
        setIsPokePageClosing(true);
        // Attend la fin de l'animation (300ms) avant de réellement fermer la page
        setTimeout(() => {
            setIsPokePageOpen(false);
            setIsPokePageClosing(false);
        }, 300); // Durée qui correspond à la transition CSS dans Dashboard.module.css
    };

    // Gestion de la fermeture de TaskPage avec animation
    const handleCloseTaskPage = () => {
        setIsTaskPageClosing(true);
        setTimeout(() => {
            setIsTaskPageOpen(false);
            setIsTaskPageClosing(false);
        }, 300);
    };

    if (isLoading) {
        return <div className={styles.loading}>Chargement...</div>;
    }

    if (!isAuthenticated) {
        return <TitlePage />;
    }

    return (
        <div className={styles.dashboardContainer}>
            <div className={styles.background}>
                <img src={`assets/backgrounds/${period}.png`} alt="" />
            </div>
            {/* <div className={`${styles.dashboardHeader} ${nightClassName()}`}>
                <div className={`${styles.idContainer} ${relief.relief}`} onClick={logout}>
                    <h2 className={styles.idText}>{user.username}</h2>
                </div>
                <div className={`${styles.timeContainer} ${timeContainerClassName()}`}>
                    <img src={`assets/icons/extras/${period}.svg`} alt="" />
                    <div className={styles.periodOverlay}></div>
                </div>
            </div> */}

            <div className={styles.user}></div>

            <PhaserGame className={styles.phaser} user={user} pokemon={selectedPokemon} period={period} />
            <div className={styles[period]}></div>

            {/* Conteneur principal qui gère les animations */}
            <div className={`${styles.contentPage} 
                ${/* Ajoute la classe visible si une des pages est ouverte */
                (isPokePageOpen || isTaskPageOpen || isProfilePageOpen) ? styles.visible : ''} 
                ${/* Ajoute la classe invisible pendant l'animation de sortie */
                (isPokePageClosing || isTaskPageClosing || isProfilePageClosing) ? styles.invisible : ''}`}>

                {/* Rendu conditionnel des pages */}
                {isProfilePageOpen && (
                    <ProfilePanel 
                        period={period}
                        onClose={handleCloseProfilePage}
                    />
                )}
                {isPokePageOpen && (
                    <PokemonPage 
                        period={period}
                        onClose={handleClosePokePage}
                    />
                )}
                {isTaskPageOpen && (
                    <TaskPage 
                        period={period}
                        onClose={handleCloseTaskPage}
                    />
                )}
            </div>
            <div className={styles.footer}>
                                {/* Boutons avec vérification pour éviter les clics multiples */}
                    <div className={`${styles.profile}`}
                        onClick={() => !isProfilePageOpen && setIsProfilePageOpen(true)}>
                        <svg width="38" height="38" viewBox="0 0 699 838" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M698.218 693.317C699.106 730.215 687.089 766.266 664.239 795.252C654.827 808.332 642.46 819.007 628.145 826.408C613.829 833.808 597.969 837.725 581.854 837.841H116.399C100.321 837.707 84.5002 833.781 70.225 826.38C55.9497 818.98 43.6228 808.314 34.2467 795.252C11.3483 766.279 -0.747821 730.238 0.0358178 693.317C-0.159095 663.85 1.39515 634.397 4.69036 605.113C7.89839 576.954 13.6628 549.144 21.9122 522.03C29.216 497.159 39.9469 473.425 53.7958 451.513C66.7722 431.476 84.32 414.806 104.996 402.873C127.392 390.148 152.782 383.64 178.538 384.022C200.825 406.521 227.417 424.299 256.726 436.294C286.035 448.29 317.461 454.257 349.127 453.841C380.832 454.289 412.302 448.337 441.653 436.34C471.004 424.344 497.634 406.55 519.949 384.022C545.717 383.537 571.133 390.052 593.49 402.873C614.114 414.876 631.646 431.532 644.69 451.513C658.598 473.643 669.331 497.615 676.574 522.728C684.804 549.61 690.569 577.186 693.796 605.113C696.892 634.411 698.369 663.857 698.218 693.317ZM497.141 61.4625C516.949 80.6295 532.619 103.651 543.186 129.108C553.753 154.565 558.993 181.917 558.581 209.477C558.993 237.037 553.753 264.389 543.186 289.846C532.619 315.303 516.949 338.325 497.141 357.492C477.974 377.299 454.952 392.97 429.495 403.537C404.039 414.104 376.687 419.343 349.127 418.932C321.567 419.343 294.215 414.104 268.758 403.537C243.301 392.97 220.279 377.299 201.112 357.492C181.305 338.325 165.634 315.303 155.067 289.846C144.5 264.389 139.261 237.037 139.672 209.477C139.261 181.917 144.5 154.565 155.067 129.108C165.634 103.651 181.305 80.6295 201.112 61.4625C220.279 41.6549 243.301 25.9843 268.758 15.4173C294.215 4.85025 321.567 -0.389065 349.127 0.0224966C376.687 -0.389065 404.039 4.85025 429.495 15.4173C454.952 25.9843 477.974 41.6549 497.141 61.4625Z" fill="#3B3B3B"/>
                        </svg>

                    </div>
                    <div className={styles.verticalSeparator}></div>
                    <div className={`${styles.ball}`} 
                        onClick={() => !isPokePageOpen && setIsPokePageOpen(true)}>
                        <svg width="40" height="40" viewBox="0 0 1024 1024" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M874.04 149.96C777.336 53.256 648.76 0 512 0C375.24 0 246.664 53.256 149.96 149.96C53.256 246.664 0 375.24 0 512C0 648.76 53.256 777.336 149.96 874.04C246.664 970.744 375.24 1024 512 1024C605.389 1024.06 697.012 998.544 776.92 950.208C785.86 944.649 792.248 935.79 794.699 925.552C797.15 915.314 795.466 904.522 790.012 895.518C784.559 886.513 775.775 880.021 765.567 877.45C755.358 874.879 744.548 876.436 735.48 881.784C668.067 922.545 590.778 944.062 512 944C287.28 944 102.12 771.52 81.864 552H336.488C354.72 632.064 426.48 692 512 692C597.504 692 669.28 632.064 687.52 552H942.128C935.472 622.992 911.136 691.36 870.752 751.776C867.759 756.141 865.663 761.056 864.583 766.238C863.504 771.419 863.464 776.763 864.465 781.96C865.466 787.156 867.488 792.103 870.415 796.513C873.341 800.922 877.114 804.707 881.513 807.649C885.913 810.59 890.853 812.629 896.047 813.647C901.24 814.665 906.584 814.643 911.769 813.581C916.953 812.519 921.876 810.439 926.251 807.461C930.626 804.483 934.367 800.666 937.256 796.232C994 711.36 1024 613.064 1024 512C1024 375.24 970.744 246.664 874.04 149.96ZM512 80C736.72 80 921.88 252.48 942.136 472H687.512C669.28 391.936 597.52 332 512 332C426.496 332 354.72 391.936 336.48 472H81.872C102.12 252.48 287.28 80 512 80ZM512 612C456.856 612 412 567.144 412 512C412 456.856 456.856 412 512 412C567.144 412 612 456.856 612 512C612 567.144 567.144 612 512 612Z" fill="#3B3B3B"/>
                        </svg>
                    </div>
                    <div className={`${styles.list}`} 
                        onClick={() => !isTaskPageOpen && setIsTaskPageOpen(true)}>
                        <svg width="40" height="40" viewBox="0 0 429 470" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M181.687 323.162C177.225 323.162 172.762 321.412 169.35 318L105.703 254.353C102.42 251.07 100.575 246.616 100.575 241.972C100.575 232.302 108.414 224.462 118.085 224.462C122.729 224.462 127.182 226.307 130.466 229.591L168.258 267.383C175.675 274.801 187.702 274.803 195.122 267.388L284.716 177.862C291.556 171.027 302.641 171.029 309.479 177.866C316.318 184.706 316.318 195.794 309.479 202.634L194.112 318C190.7 321.412 186.15 323.162 181.687 323.162Z" fill="#3B3B3B"/>
                            <path d="M375.937 469.113H52.975C24.0125 469.113 0.474976 445.575 0.474976 416.612V53.3125C0.474976 24.35 24.0125 0.8125 52.975 0.8125H138.287C147.912 0.8125 155.787 8.68749 155.787 18.3125V53.8375C155.787 56.9875 158.325 59.525 161.475 59.525H267.438C270.587 59.525 273.125 56.9875 273.125 53.8375V18.3125C273.125 8.68749 281 0.8125 290.625 0.8125H375.937C404.9 0.8125 428.438 24.35 428.438 53.3125V416.612C428.438 445.575 404.9 469.113 375.937 469.113ZM52.975 35.8125C43.35 35.8125 35.475 43.6875 35.475 53.3125V416.612C35.475 426.237 43.35 434.112 52.975 434.112H375.937C385.562 434.112 393.438 426.237 393.438 416.612V53.3125C393.438 43.6875 385.562 35.8125 375.937 35.8125H308.125V53.8375C308.102 64.6214 303.808 74.957 296.182 82.5824C288.557 90.2078 278.221 94.5019 267.438 94.525H161.475C150.691 94.5019 140.355 90.2078 132.73 82.5824C125.105 74.957 120.811 64.6214 120.787 53.8375V35.8125H52.975Z" fill="#3B3B3B"/>
                        </svg>
                    </div>

            </div>
        </div>
    );
};

export default Dashboard;
